import React, { useContext } from 'react';

const MenuContext = React.createContext();
export const MenuProvider = MenuContext.Provider;
export const MenuConsumer = MenuContext.Consumer;

export const initialMenuState = {
  menu: null,
  isOpen: false,
};

export const withMenu = (Component) => {
  return (props) => (
    <MenuConsumer>
      {({ menu, setMenu, isOpen, setOpen }) => (
        <Component
          menu={menu}
          setMenu={setMenu}
          isOpen={isOpen}
          setOpen={setOpen}
          {...props}
        />
      )}
    </MenuConsumer>
  );
};

export const useMenu = () => useContext(MenuContext);

export default MenuContext;
